import { render, staticRenderFns } from "./StoreCashboxes.vue?vue&type=template&id=4720d447&"
import script from "./StoreCashboxes.vue?vue&type=script&lang=js&"
export * from "./StoreCashboxes.vue?vue&type=script&lang=js&"
import style0 from "./StoreCashboxes.vue?vue&type=style&index=0&id=4720d447&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports